module.exports = __webpack_public_path__ + "static/media/Bulk_tickets_update_file.e59b87b9.csv";